<!-- Componente de Diálogo (DialogComponent.vue) -->
<template>
  <div v-if="isVisible" class="dialog-overflow">
    <div class="dialog-container">
      <!-- Contenido del diálogo -->
      <div class="dialog">
        <div class="px-4 pt-4 d-flex justify-space-between align-center">
          <h3>Opciones</h3>
          <button @click="closeDialog"><v-icon class="fas fa-times" size="20" color="black" /></button>
        </div>
        <!-- Más contenido del diálogo aquí -->
        <div class="pa-4">
          <v-radio-group v-model="option" mandatory :style="{ height: 'auto', margin: '0px' }">
            <v-radio v-for="(o, index) in message.options" :key="index" :value="o" class="red--text">
              <template #label>
                <v-icon v-if="o.hidden" x-small color="error" class="mr-1"> fas fa-eye-slash</v-icon> {{ o.title }}
              </template>
            </v-radio>
          </v-radio-group>

          <v-btn color="primary" block @click="onSelectedOption"> Enviar </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isVisible: true,
      option: null,
    };
  },
  methods: {
    closeDialog() {
      //   this.isVisible = false;
      this.$emit("closeDialog", this.option);
    },
    onSelectedOption() {
      this.$emit("closeDialog", this.option);
      const index = this.message.options.findIndex((item) => item == this.option);
      this.$emit(
        "onSelectedMenuOption",
        {
          ...this.message,
          reply: this.option.title,
          selected_id: this.option.id,
          index: index,
        },
        index,
      );
    },
  },
};
</script>

<style>
.dialog-overflow {
  position: absolute;
  height: 100%;
  top: 1px;
  left: 11px;
  width: 93%;
  background-color: #0000001f;
  border-radius: 31px;
}
.dialog {
  position: absolute;
  bottom: 4px;
  width: 100%;
  background: white;
  border-radius: 12px 12px 0px 0px;
  /* padding: 16px; */
  max-height: 80%;
  overflow-y: auto;
  border-radius: 13px;
}

/* .dialog {
  position: absolute; 
  bottom: 0;
  width: 100%;
} */
</style>
